import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-tabs',
  templateUrl: './ui-tabs.component.html',
  styleUrls: ['./ui-tabs.component.scss']
})
export class UiTabsComponent implements OnInit {
  homeTab: boolean = true;
  profileTab: boolean;
  contactTab: boolean;
  contactPil: boolean;
  homePil: boolean = true;
  profilePil: boolean;
  homePilV: boolean = true;
  profilePilV: boolean;
  messagesPilV: boolean;
  settingsPilV: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.homeTab = false;
    this.profileTab = false;
    this.contactTab = false;
    if (number == '1') {
      this.homeTab = true;
    }
    else if (number == '2') {
      this.profileTab = true;
    }
    else if (number == '3') {
      this.contactTab = true;
    }
  }

  onMenuPill(number) {
    this.homePil = false;
    this.profilePil = false;
    this.contactPil = false;
    if (number == '1') {
      this.homePil = true;
    }
    else if (number == '2') {
      this.profilePil = true;
    }
    else if (number == '3') {
      this.contactPil = true;
    }
  }

  onMenuPillV(number) {
    this.homePilV = false;
    this.profilePilV = false;
    this.messagesPilV = false;
    this.settingsPilV = false;
    if (number == '1') {
      this.homePilV = true;
    }
    else if (number == '2') {
      this.profilePilV = true;
    }
    else if (number == '3') {
      this.messagesPilV = true;
    }

    else if (number == '4') {
      this.settingsPilV = true;
    }
  }

}
